// src/services/serviceService.js
import { createServices } from '@/data/faker';

let servicesCache = null;

export const getServices = (count = 100) => {
    if (!servicesCache) {
        servicesCache = createServices(count); // Initialize cache
    }
    return servicesCache;
};

export const fetchServiceById = async (id) => {
    if (!servicesCache) {
        getServices(); // Populate cache if empty
    }
    return servicesCache.find(service => service.id === id);
};
